import { Col, Table } from "reactstrap";
import { conversionRateTableBody } from "../../../../Data/Dashboard/EcommerceDashboard/EcommerceDashboard";
import RegularCustomers from "./RegularCustomers";

const ConversionRateTable = () => {
  return (
    <Col xl="6" lg="12" sm="6">
      <Table className="conversion-table">
        <thead>
          <tr>
            <th>Year</th>
            <th>Customers</th>
            <th>Trend</th>
            <th>Revenue</th>
          </tr>
        </thead>
        <tbody>
          {conversionRateTableBody.map((data, i) => (
            <tr key={i}>
              <td>{data.year}</td>
              <td>{data.customers}</td>
              <td>{data.trend}</td>
              <td>{data.revenue}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <RegularCustomers />
    </Col>
  );
};

export default ConversionRateTable;
